import { stringify } from 'qs';
import ILoadsLocationResponse from '../../../components/load-filters/interfaces/ILoadsLocationResponse';
import IApiResponse from '../../../interfaces/IApiResponse';
import IPagination from '../../../interfaces/IPagination';
import { getRoundManagerApiAxiosInstance } from '../../axios-config';
import ILoadsLocationModel from '../../../interfaces/loads/ILoadsLocationModel';

// eslint-disable-next-line import/prefer-default-export
export const getLoadsLocation = async (
    filters?: ILoadsLocationModel,
): Promise<IApiResponse<IPagination<ILoadsLocationResponse>>> => {
    const request = {
        Search: filters?.search,
        SearchFederativeUnit: filters?.searchFederativeUnit,
        LocationType: filters?.locationType,
        _page: 1,
        _size: 100,
    };
    try {
        const Api = await getRoundManagerApiAxiosInstance();

        const response = await Api.get('v1/loads/locations:paginated', {
            params: request,
            paramsSerializer(params) {
                return stringify(params, { allowDots: true });
            },
        });

        return { response: response.data };
    } catch (error: any) {
        return {
            error: new Error((error as { message: string }).message),
        };
    }
};
